export default __webpack_public_path__ + "static/media/1.c2e1ab8b.png";